//Generated File 
export const Disabled = `Disabled`;
export const MoreThanOne = `MoreThanOne`;
export const One = `One`;
